// Please update the version only when pushed to web environment
// DO NOT MOVE LINES, script will replace fixed line numbers
export default {
  // version of product, please increase when pushing changes
  version: "1.0.0",
  // flag to enable features under test environment
  test: false,
  DEBUG: false,
  accountId: "A00000000",
  mainUrl: "https://test05.superlinda.nl",
  login: {
    clientSecret: "FvgpqmRajFLy5RAW2OpdHH7R4yW1aZjAWjVt394e"
  },
  // name of images without path and type(jpg or png), images must be located in assets folder
  mainImages: {
    logoImage: "-logo",
    headerImage: "-homePage",
    previewImage: "-app",
    registerSuccesImage: "-register-succes",
    eventSuccesImage: "-event-succes",
    loginImage: "-login"
  },
  dss: {
    communicationManagerId: "LocationsNode_CMR",
    url: "https://admin.start.superlinda.nl:4010/",
    userKernelNodeName: "LocationsNode",
    locationMgr: "LocationsNode_LM",
    environmentName: "TheDrivingForce",
    tripManagerId: "LocationsNode_TM",
    accountManagerObjectId: "LocationsNode_AM",
    environments: {
      accountId: "A00000000"
    },
    eventAdminMng: "LocationsNode_EAM"
  },
  Userlogin: {
    clientId: 1,
    clientSecret: "Ygjn5YaXZVDxJrnekZtsmdDPgQphVu03iFtKZTSc"
  },
  AndroindAppUrl: {
    // android app url
    url: "https://play.google.com/store/apps/details?id=nl.thedrivingforce.miht"
  },
  IOSAppUrl: {
    // IOS url
    url:
      "https://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1395195160&mt=8"
  },
  map: {
    // map stuff
    center: [4.839374, 52.241618],
    zoom: 12,
    minZoom: 7,
    maxZoom: 18
  },
  webSession: {
    // websession
    url: "wss://admin.start.superlinda.nl:11581/"
  },
  tileServer: {
    // Connectivity through the tile server using tile.thedrivingforce.nl
    base: "https://tile.thedrivingforce.nl/osm_tiles",
    url: "https://tile.thedrivingforce.nl/osm_tiles/{z}/{x}/{y}.png"
  },
  // footer information
  footerInfo: {
    park: "The Driving Force B.V.",
    email: "administrator@thedrivingforce.nl",
    adress: "1422 AK Uithoorn,",
    website: "INFO@THEDRIVINGFORCE.NL"
  },
  maxSize: {
    arrivalAudioSize: 1048576,
    departureAudioSize: 1048576,
    pictureSize: 10000000,
    logo: {
      h: 120,
      w: 475
    },
    home: {
      h: 720,
      w: 1280
    }
  }
};
